/**
 * School-started setups, as staff provisioning candidates (release lines U10,
 * R18, KTD12).
 *
 * GET /v1/mobile-apps/setup-candidates (super-admin)
 *
 * Every app a school started through the self-service setup and staff have not
 * provisioned yet: not deleted, still `PROVISIONING`, no bundle id. That is
 * exactly the row a provisioning run for the school adopts, so this list is the
 * set of schools a run would pick up rather than create for. Newest first, each
 * with how complete its setup is.
 */

import { z } from 'zod'
import { SchoolAppSetupCompletenessSchema } from '../../schemas/entities/school-app-setup'

export const SchoolAppSetupCandidateSchema = z.object({
  /** `MobileApp.publicId`. */
  appId: z.string(),
  /** `School.publicId`, what the provisioning wizard's school field takes. */
  schoolId: z.string(),
  schoolName: z.string().nullable(),
  /** When the school started the setup. */
  startedAt: z.string().datetime(),
  completeness: SchoolAppSetupCompletenessSchema
})
export type SchoolAppSetupCandidate = z.infer<typeof SchoolAppSetupCandidateSchema>

export const ListSchoolAppSetupCandidatesResponseSchema = z.object({
  candidates: z.array(SchoolAppSetupCandidateSchema)
})
export type ListSchoolAppSetupCandidatesResponse = z.infer<typeof ListSchoolAppSetupCandidatesResponseSchema>
